// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QbV2k","badges":"styles_badges__265tF"};